export default "/assets/images/best-product-award-badge.svg?68f9a50b943d324f3833d9bc04b035cd";